import { defineMessages } from 'react-intl';

export default defineMessages({
    doYouWishToContinue: {
        id: 'app.components.confirmationModal.doYouWishToContinue',
        defaultMessage: 'Do you wish to continue?'
    }
});



// WEBPACK FOOTER //
// ./app/components/confirmation/messages.js